/** Full-viewport confetti burst from the top, for passing Check My Work. */
export function celebratePassing(): void {
  if (typeof document === "undefined") return;

  const canvas = document.createElement("canvas");
  canvas.className = "confetti-canvas";
  canvas.setAttribute("aria-hidden", "true");
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  document.body.appendChild(canvas);

  const ctx = canvas.getContext("2d");
  if (!ctx) {
    canvas.remove();
    return;
  }

  const palette = ["#22a85a", "#6ba336", "#fbbf24", "#5b8fd4", "#f0a030", "#c41e3a", "#fdf9f3", "#1b4d2e"];
  const shapes = ["rect", "circle", "ribbon"] as const;

  type Particle = {
    x: number;
    y: number;
    vx: number;
    vy: number;
    w: number;
    h: number;
    rot: number;
    spin: number;
    color: string;
    shape: (typeof shapes)[number];
    opacity: number;
  };

  const count = Math.min(220, Math.floor(window.innerWidth / 4));
  const particles: Particle[] = Array.from({ length: count }, () => ({
    x: Math.random() * canvas.width,
    y: -12 - Math.random() * canvas.height * 0.35,
    vx: (Math.random() - 0.5) * 2.4,
    vy: 2.2 + Math.random() * 3.8,
    w: 5 + Math.random() * 7,
    h: 4 + Math.random() * 10,
    rot: Math.random() * Math.PI * 2,
    spin: (Math.random() - 0.5) * 0.22,
    color: palette[Math.floor(Math.random() * palette.length)]!,
    shape: shapes[Math.floor(Math.random() * shapes.length)]!,
    opacity: 0.85 + Math.random() * 0.15,
  }));

  const started = performance.now();
  const durationMs = 3200;

  const onResize = () => {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  };
  window.addEventListener("resize", onResize);

  const draw = (now: number) => {
    const t = now - started;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    for (const p of particles) {
      p.vy += 0.045;
      p.vx *= 0.998;
      p.x += p.vx;
      p.y += p.vy;
      p.rot += p.spin;

      if (t > durationMs * 0.55) {
        p.opacity = Math.max(0, p.opacity - 0.018);
      }

      ctx.save();
      ctx.globalAlpha = p.opacity;
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.fillStyle = p.color;

      if (p.shape === "circle") {
        ctx.beginPath();
        ctx.arc(0, 0, p.w * 0.45, 0, Math.PI * 2);
        ctx.fill();
      } else if (p.shape === "ribbon") {
        ctx.fillRect(-p.w * 0.5, -p.h * 0.15, p.w, p.h * 0.3);
      } else {
        ctx.fillRect(-p.w * 0.5, -p.h * 0.5, p.w, p.h);
      }
      ctx.restore();
    }

    if (t < durationMs) {
      requestAnimationFrame(draw);
    } else {
      window.removeEventListener("resize", onResize);
      canvas.remove();
    }
  };

  requestAnimationFrame(draw);
}
